import SidePanelMenu, { SidePanelMenuItemProps } from '@bt-react/components/SidePanelMenu'
import { IconType } from '@bt-react/components/Icon'
import { SidePanelTypes } from '@bt-react/constants'
import { connect } from 'react-redux'
import { State } from '../../../dataStore/reducers/reducerType'
import { closeSidePanel, setSelectedMenuItem } from '../../../dataStore/actions/ui/uiActions'

type Dispatch = 'onClick'

const mapStateToProps = (state: State, props: Pick<SidePanelMenuItemProps, 'panel'>): Omit<SidePanelMenuItemProps, Dispatch> => {

  const selected = state.ui.menuItemSelected === props.panel

  const voteCount = () => {
    const currentLiveVote = state.votes.votes.find(vote => vote.status === 'open')
    return currentLiveVote?.options.reduce((acc, option) => acc += (option?.total ?? 0), 0)
  }

  return {
    dataBdd: props.panel,
    title: 'Votes',
    icon: IconType.iconName.votes,
    panel: props.panel,
    key: `side-panel-${props.panel}`,
    selected,
    isActive: selected && state.ui.isSidePanelOpen,
    notifications: voteCount(),
    tooltipText: 'Polls'
  }

}

const mapDispatchToProps = (dispatch): Pick<SidePanelMenuItemProps, Dispatch> => ({
  onClick: (panel: SidePanelTypes, isActive) => isActive ? dispatch(closeSidePanel()) : dispatch(setSelectedMenuItem(panel))
})

export default connect(mapStateToProps, mapDispatchToProps)(SidePanelMenu.Item)
